import { Download } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

const FACTS = [
  { value: "15+", label: "années d'intervention en situations critiques au sein du SI" },
  { value: "30", label: "experts encadrés sur programmes critiques" },
  { value: "4", label: "secteurs stratégiques couverts" },
  { value: "3", label: "certifications de référence — CISSP · ISO 27001 · ISO 42001" },
];

const SECTORS = [
  "Pharma & Santé",
  "Banque & Services financiers",
  "Industrie",
  "Édition logicielle & SaaS",
];

const EXPERTISES = [
  "Direction des systèmes d'information",
  "Cybersécurité & gouvernance des risques",
  "ERP (SAP, Oracle, PeopleSoft, Odoo)",
  "Cloud (AWS, Azure)",
  "Gestion de crise & continuité d'activité",
  "Conduite du changement",
];

export default function Credibility() {
  return (
    <section
      id="credibilite"
      data-testid="credibility-section"
      className="py-24 sm:py-36 px-6 sm:px-10 lg:px-16 bg-[#FAF8F5]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="reveal max-w-3xl mb-16">
          <p className="eyebrow flex items-center mb-6">
            <span className="gold-line" />
            Crédibilité & repères d'intervention
          </p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl text-[#0B132B] leading-[1.1]">
            Un parcours <span className="italic">au service du réel.</span>
          </h2>
          <p className="mt-6 text-[#4A5568] leading-relaxed font-light text-lg">
            Plus de 15 ans en direction des systèmes d'information, dans des
            contextes de crise, de transformation critique et de réorganisation
            profonde. Une pratique de terrain construite au contact de grands
            groupes internationaux, d'ETI structurées et d'environnements
            sensibles où la continuité, la gouvernance et l'exécution ne
            peuvent pas être approximatives.
          </p>
        </div>

        {/* Repères d'intervention */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-[#E2DCD0] border border-[#E2DCD0] mb-20">
          {FACTS.map((f, i) => (
            <div
              key={f.label}
              data-testid={`fact-${i}`}
              className="reveal bg-[#FAF8F5] p-8 sm:p-10"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <p className="font-serif italic text-5xl sm:text-6xl text-[#0B132B] leading-none">
                {f.value}
              </p>
              <p className="mt-4 text-xs sm:text-sm uppercase tracking-[0.12em] text-[#4A5568] leading-relaxed">
                {f.label}
              </p>
            </div>
          ))}
        </div>

        {/* Two columns */}
        <div className="grid lg:grid-cols-2 gap-16">
          <div className="reveal">
            <p className="eyebrow mb-5">Secteurs d'intervention</p>
            <ul className="space-y-3">
              {SECTORS.map((s) => (
                <li
                  key={s}
                  className="flex items-baseline gap-3 text-[#171D2A] font-light text-lg border-b border-[#E2DCD0] pb-3"
                >
                  <span className="text-[#C8A97E] font-serif italic">—</span>
                  {s}
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm text-[#4A5568] italic font-light">
              Contextes : grands groupes internationaux, ETI structurées,
              environnements régulés — santé, finance, industrie, édition
              logicielle.
            </p>
          </div>

          <div className="reveal">
            <p className="eyebrow mb-5">Domaines d'expertise</p>
            <ul className="space-y-3">
              {EXPERTISES.map((e) => (
                <li
                  key={e}
                  className="flex items-baseline gap-3 text-[#171D2A] font-light text-lg border-b border-[#E2DCD0] pb-3"
                >
                  <span className="text-[#C8A97E] font-serif italic">—</span>
                  {e}
                </li>
              ))}
            </ul>
            <a
              href="/cv-olivier-soutarson.pdf"
              data-testid="credibility-cv-link"
              onClick={() => trackEvent("cv_download", { location: "home_credibility" })}
              className="mt-8 inline-flex items-center gap-3 text-[#0B132B] border-b border-[#0B132B] pb-1 hover:text-[#C8A97E] hover:border-[#C8A97E] transition-colors text-sm uppercase tracking-[0.14em]"
            >
              <Download size={15} />
              Voir le CV complet
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
